import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { ApiService } from '../../core/upgraded-providers';

@Injectable()
export class AllOrdersResolves implements Resolve<any> {

    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): angular.IPromise<any> {
        return this._apiService
            .get('user/world-start-room', { })
            .then(({ room }) => {
                let shard = 'shard0';

                if (room[0]) {
                    shard = room[0].match(/^(.*)\/(.*)$/);
                    shard = shard && shard[1];
                }

                return shard;
            });
    }
}
